import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { DataService_ScheduledJobs } from "../shared/data.service";
import { RiJobAddComponent } from "./ri-job-add/ri-job-add.component";
import { RiJobEditComponent } from "./ri-job-edit/ri-job-edit.component";
import { ConfirmationService } from "primeng/api";
import { MenuService } from "../../../master/services";

@Component({
	selector: "caass-ri-job-table",
	templateUrl: "./ri-job-table.component.html",
	styleUrls: ["./ri-job-table.component.css"],
})
export class RiJobTableComponent implements OnInit {
	constructor(
		private dataService: DataService_ScheduledJobs,
		private dialogService: DialogService,
		private confirmationService: ConfirmationService,
		private menuService: MenuService
	) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.loadJobs();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	@Output() JobSelected: EventEmitter<any> = new EventEmitter();

	pagerows: any = 10;
	pagefirst: any = 0;
	TableLoading: any = false;
	errorMessage: any = "";

	//Main
	SelectedJob: any;
	lstJob: any = [];

	//Filter lists
	lstActiveDesc: any = [];

	ToggleText: string = "Deactivate Job";
	Processing: boolean = false;

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadJobs() {
		this.onRowUnselect(null);
		this.TableLoading = true;

		var result = this.dataService.JobMainTableSelectList();
		result.subscribe(
			(response) => {
				this.lstJob = response;

				//Load Data Filter Lists
				this.lstActiveDesc = Array.from(new Set(this.lstJob.map((item: any) => item.ActiveDesc))).sort();

				this.TableLoading = false;

				this.menuService.reportInboxChanged("Refresh");
			},
			(error) => {
				this.TableLoading = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.loadJobs();
	}

	onAdd() {
		this.errorMessage = "";

		var ref = this.dialogService.open(RiJobAddComponent, {
			header: "Add Job",
			width: "fit-content",
			data: {},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadJobs();
			}
		});
	}

	onEdit() {
		this.errorMessage = "";

		if (this.SelectedJob == undefined || this.SelectedJob.JobID <= 0) {
			this.errorMessage = "Select a job to edit";
			return;
		}

		if (this.SelectedJob.CanEdit == false) {
			this.errorMessage = "User does not have permission to edit this job";
			return;
		}

		var ref = this.dialogService.open(RiJobEditComponent, {
			header: "Edit Job",
			width: "fit-content",
			data: {
				JobID: this.SelectedJob.JobID,
				JobDesc: this.SelectedJob.JobDesc,
				ReportScriptID: this.SelectedJob.ReportScriptID,
				Active: this.SelectedJob.Active,
				lstParameters: this.SelectedJob.lstParameters,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadJobs();
			}
		});
	}

	onRunJob() {
		this.errorMessage = "";

		if (this.SelectedJob == undefined || this.SelectedJob.JobID <= 0) {
			this.errorMessage = "Select a job to run";
			return;
		}

		// if (this.SelectedJob.CanEdit == false) {
		// 	this.errorMessage = "User does not have permission to run this job";
		// 	return;
		// }

		this.Processing = true;
		var result = this.dataService.ProcessJob(this.SelectedJob.JobID);
		result.subscribe(
			(response: any) => {
				if (response.Success == true) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "reportinboxjob",
						acceptLabel: "Ok",
						rejectVisible: false,
						message:
							"Job was run successfully. Check your Inbox page in CAASS to see the results of the report. Note: this report was sent to all of the assigned recipients.",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.menuService.reportInboxChanged("Refresh");
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "reportinboxjob",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not run the job: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
				this.Processing = false;
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onToggle() {
		this.errorMessage = "";

		if (this.SelectedJob == undefined || this.SelectedJob.JobID <= 0) {
			this.errorMessage = "Select a job to deactivate";
			return;
		}

		if (this.SelectedJob.CanEdit == false) {
			this.errorMessage = "User does not have permission to edit this job";
			return;
		}

		this.Processing = true;
		var result = this.dataService.JobToggle(this.SelectedJob.JobID, this.SelectedJob.Active == true ? false : true);
		result.subscribe(
			(response: any) => {
				if (response.Success == true) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "reportinboxjob",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Scheduled Report was " + (this.SelectedJob.Active == true ? "deactivated" : "activated") + " successfully.",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.loadJobs();
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "reportinboxjob",
						acceptLabel: "Ok",
						rejectVisible: false,
						message:
							"Could Not " + (this.SelectedJob.Active == true ? "deactivate" : "activate") + " the scheduled report: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
				this.Processing = false;
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onDelete() {
		this.errorMessage = "";

		if (this.SelectedJob == undefined || this.SelectedJob.JobID <= 0) {
			this.errorMessage = "Select a job to delete";
			return;
		}

		if (this.SelectedJob.CanEdit == false) {
			this.errorMessage = "User does not have permission to delete this job";
			return;
		}

		this.confirmationService.confirm({
			key: "reportinboxjobconfirm1",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message: "Are you sure you want to delete this scheduled report? It will no longer generate the report and send it to anyone's inbox.",
			header: "Confirm Delete",
			icon: "fa",
			accept: () => {
				this.onDeleteConfirm(this.SelectedJob.JobID);
			},
		});
	}

	onDeleteConfirm(JobID: number) {
		this.confirmationService.confirm({
			key: "reportinboxjobconfirm2",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message: "Do you want to delete the results of this report? This will affect everyone that is receiving the report.",
			header: "Confirm Delete",
			icon: "fa",
			accept: () => {
				this.onFinishDelete(JobID, true);
			},
			reject: () => {
				this.onFinishDelete(JobID, false);
			},
		});
	}

	onFinishDelete(JobID: number, DeleteResults: boolean) {
		this.Processing = true;
		var result = this.dataService.JobDelete(JobID, DeleteResults);
		result.subscribe(
			(response: any) => {
				if (response.Success == true) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "reportinboxjob",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Scheduled Report was deleted successfully.",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.loadJobs();
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "reportinboxjob",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not delete the scheduled report: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
				this.Processing = false;
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onRowSelect(val) {
		this.SelectedJob = val.data;
		this.JobSelected.emit(this.SelectedJob);

		this.ToggleText = "Deactivate Job";
		if (this.SelectedJob.Active == false) {
			this.ToggleText = "Activate Job";
		}
	}
	onRowUnselect(val) {
		this.SelectedJob = null;
		this.JobSelected.emit(null);

		this.ToggleText = "Deactivate Job";
	}
	onRowDblClick(Job) {
		this.SelectedJob = Job;
		this.onEdit();

		this.ToggleText = "Deactivate Job";
		if (this.SelectedJob.Active == false) {
			this.ToggleText = "Activate Job";
		}
	}
	////////////////////////////////////////////

	////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////

	IsLoading() {
		return this.TableLoading == true || this.Processing == true;
	}

	////////////////////////////////////////////
}
